/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useRef, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { Backdrop } from "@mui/material";
import { useMedia } from "react-use";
import { useSimpliCity } from "@simplicitycms/simplicity-common";
import { NavMenu } from "./nav_menu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WebsiteLogo } from "layout-components/header/logo";
import { MyDnv } from "mydnv/components/sign-in";
import { QuickSearch } from "cms/search/quick-search/quick-search";
import { WhenSignedIn } from "mydnv/components/sign-in/sign_in_out_util";
import { useMyDNVContext } from "mydnv/context/mydnv-context";
import { WrappedBookmark } from "mydnv/components/bookmark/wrapped-bookmark";

/**
 *
 * @param {object} props
 * @param {() => void} props.toggleMobile
 */
const PrimaryMenu = (props) => {
    const { toggleMobile, show } = props;
    const { emailVerified, bookmarks, showBookmarksTip, setShowBookmarksTip, setShowVerifiedTip } = useMyDNVContext();
    const { menu } = useSimpliCity();
    const isMobileOrTablet = useMedia("screen and (max-width: 1124px)");
    // const isMobile = useMedia("screen and (max-width: 480px)");

    const parsedBookmarks = bookmarks !== undefined ? JSON.parse(bookmarks) : [];

    const tooltipRef = useRef(null);

    const handleTooltipClose = () => {
        setShowBookmarksTip(false);
        if (localStorage.getItem("not-signedin-bookmark") !== null) {
            setShowVerifiedTip(true);
            localStorage.removeItem("not-signedin-bookmark");
        }
    };

    useEffect(() => {
        if (tooltipRef.current) {
            if (showBookmarksTip) {
                tooltipRef.current.focus();
            }
        }
    }, [showBookmarksTip]);

    return (
        <div className="primary-menu">
            {isMobileOrTablet && (
                <a href="#skip-content-start" className="skip-link mobile">
                    Skip to main content
                </a>
            )}
            <div className="primary-menu-content">
                {/*desktop menu*/}
                <div className="primary-menu-content-menu-mobile">
                    <div className={"primary-menu-content-menu-mobile left-side " + (show ? "open" : "")}>
                        <button onClick={toggleMobile}>
                            <div>
                                <FontAwesomeIcon icon={`fa-regular fa-bars`}/>
                            </div>
                        </button>
                        <div className="primary-menu-content-logo">
                            <WebsiteLogo/>
                        </div>
                    </div>
                    <div className={"primary-menu-content-menu-mobile right-side " + (show ? "open" : "")}>
                        <ul className="myDNV">
                            <li>
                                <QuickSearch/>
                            </li>

                            <WhenSignedIn>
                                {emailVerified && isMobileOrTablet && (
                                    <li className={parsedBookmarks.length === 0 ? "hidden" : ""}>
                                        <Tooltip
                                            ref={tooltipRef}
                                            classes={{ popper: "bookmarks-tooltip" }}
                                            open={showBookmarksTip}
                                            disableFocusListener
                                            disableHoverListener
                                            disableTouchListener
                                            arrow
                                            slotProps={{
                                                popper: {
                                                    disablePortal: true,
                                                    role: "dialog"
                                                }
                                            }}
                                            title={
                                                <React.Fragment>
                                                    <h4>New bookmark</h4>
                                                    <p>Quickly access your bookmarked pages from one place.</p>
                                                    <button title="Close tooltip" onClick={handleTooltipClose}>
                                                        Ok, got it
                                                    </button>
                                                </React.Fragment>
                                            }
                                            placement="bottom-start"
                                        >
                                            <WrappedBookmark/>
                                        </Tooltip>
                                        <Backdrop
                                            sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                                            open={showBookmarksTip}
                                        ></Backdrop>
                                    </li>
                                )}
                            </WhenSignedIn>

                            <li>{isMobileOrTablet && <MyDnv/>}</li>
                        </ul>
                    </div>
                </div>

                {!isMobileOrTablet && menu.map((menuItem, index) => {
                    // console.info(`${menuItem.title} ${menuItem.hide_in_nav}`);
                    return (
                        <NavMenu
                            submenu1Item={menuItem}
                            side={index < 2 ? "right" : "left"}
                            position={index}
                            size={menu.length}
                            key={index}
                        />
                    );
                })}

                {/* <div className="primary-menu-content-menu simplicity-menu-wrapper menu-level-1">
                    <Menu level={1} side={side} position={1} id="simplicity-menu-level1">
                        {menu.map((item, index) => (
                            <MenuItem
                                parent_postion={1}
                                position={index}
                                level={0}
                                side={index < 2 ? "right" : "left"}
                                size={menu.length}
                                title={item.title}
                                url={item.url}
                                nav_children={item.children}
                                key={item.url}
                            />
                        ))}
                    </Menu>
                </div> */}
            </div>
        </div>
    );
};

export { PrimaryMenu };
